export default "__VITE_ASSET__BqnIWa6I__"